/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Integration_Status_CheckingInputs */

const en_ui_integration_status_checking = /** @type {(inputs: Ui_Integration_Status_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking key…`)
};

const de_ui_integration_status_checking = /** @type {(inputs: Ui_Integration_Status_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Key wird geprüft…`)
};

/**
* | output |
* | --- |
* | "Checking key…" |
*
* @param {Ui_Integration_Status_CheckingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_integration_status_checking = /** @type {((inputs?: Ui_Integration_Status_CheckingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Integration_Status_CheckingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_integration_status_checking(inputs)
	return de_ui_integration_status_checking(inputs)
});